// Polyfills
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import 'moment/locale/fi';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import NoInternetConnect from './components/NoInternetConnect';

// Font Awesome and Open Sans
import '~styles/imports.scss';

import * as cordovaUtils from './utils/cordova.utils';
import Root from './root';
import { store } from './store';
import {
  config,
  changeServer,
  changeAuthProvider,
  readEmmConfig,
} from './configuration';

const rootNode = document.getElementById('app');
let root = null;

const render = Comp => {
  root = createRoot(rootNode);
  root.render(
    <Provider store={store}>
      <Comp />
    </Provider>
  );
};

if (!window.cordova) render(Root);

/* ====================== CORDOVA THINGS FOR HERE ON ======================= */

const renderMobile = () => {
  console.log('Rendering mobile app ui.');
  root = createRoot(rootNode);
  root.render(
    <Provider store={store}>
      <Root />
    </Provider>
  );
};

/* TODO Similar for Imprivata/mPollux? */
const switchEnv = () => {
  changeServer(prompt('Vaihda palvelinosoite', config.host));
  renderMobile();
};

const switchAuth = () => {
  changeAuthProvider(
    prompt(
      'Vaihda tunnistautumistapa',
      config.isImprivata ? 'Imprivata' : 'mPollux'
    )
  );
  renderMobile();
};

export function renderRetryPage(message) {
  console.log('Rendering mobile retry page.');
  root = createRoot(rootNode);
  root.render(
    <NoInternetConnect
      techText={message}
      tryAgain={initMobile}
      closeApp={navigator.app.exitApp}
      switchEnv={switchEnv}
      switchAuth={switchAuth}
    />
  );
}

export function initMobile() {
  console.log('Initialize mobile app.');
  readEmmConfig();

  cordovaUtils
    .authenticate()
    .then(() => {
      renderMobile();

      //
      // Uncomment to support notifications. Configured out for now (no use case, no accounts and iOS not working):
      //
      // cordovaUtils.attachNotificationHandlers(store);
    })
    .catch(e => {
      renderRetryPage(
        `InAppBrowser: ${e && e.message ? e.message : '<no info>'}`
      );
    });
}

if (window.cordova) {
  /**
   * TODO: do we want to check for updates every time the app resumes?
   * It might be annoying if the user is doing a task that gets interrupted
   * by an update that cannot be post poned.
   */

  // TODO When resuming, check authentication by pinging the server?
  // document.addEventListener('resume', cordovaUtils.checkForAppUpdates);

  document.addEventListener(
    'deviceready',
    () => {
      initMobile();
    },
    false
  );
  document.addEventListener('pause', cordovaUtils.appToBackground);
  document.addEventListener('resume', cordovaUtils.appToForeground);
}
